import React, { useEffect, useContext } from "react";
import { HoursContext } from "../contexts/HoursContext";
import { ScreenContext } from "../contexts/ScreenContext";

import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

const HoursSummary = () => {
  const { getHoursSummary, hoursSummary } = useContext(HoursContext);
  const { isMobile } = useContext(ScreenContext);

  useEffect(() => {
    getHoursSummary();
  }, []);

  return (
    <React.Fragment>
      <Grid
        container
        direction="row"
        alignItems="flex-start"
        justifyContent="space-around"
      >
        <Grid item xs={3}>
          <Typography align="right" variant="overline" display="block">
            {isMobile ? `YTD` : `Year-to-Date`}
          </Typography>
          <Typography align="right" variant="h5" display="block">
            {Math.round(hoursSummary.YTD).toFixed(2)}
          </Typography>
        </Grid>

        <Grid item xs={3}>
          <Typography align="right" variant="overline" display="block">
            {isMobile ? `MTD` : `Month-to-Date`}
          </Typography>
          <Typography align="right" variant="h5" display="block">
            {Math.round(hoursSummary.MTD).toFixed(2)}
          </Typography>
        </Grid>

        <Grid item xs={3}>
          <Typography align="right" variant="overline" display="block">
            {isMobile ? `WTD` : `This Week`}
          </Typography>
          <Typography align="right" variant="h5" display="block">
            {Math.round(hoursSummary.WTD).toFixed(2)}
          </Typography>
        </Grid>

        <Grid item xs={3}>
          <Typography align="right" variant="overline" display="block">
            {isMobile ? `Today` : `Today's Hours`}
          </Typography>
          <Typography align="right" variant="h5" display="block">
            {Math.round(hoursSummary.TODAY).toFixed(2)}
          </Typography>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default HoursSummary;
